import React, { useState } from 'react';
import Tesseract from 'tesseract.js';
// import { useSpeechRecognition } from 'react-speech-recognition';

const App = () => {
  const [dialogText, setDialogText] = useState([]);
  const [currentParticipant, setCurrentParticipant] = useState('');
  const [lineIndex, setLineIndex] = useState(0);
  // const [isRecording, setIsRecording] = useState(false);
  const [ocrProcessing, setOcrProcessing] = useState(false);
  const [phase, setPhase] = useState(1); // 1: Upload, 2: Show Text, 3: Practice
  const [showEntireText, setShowEntireText] = useState(false);
  // const { transcript, resetTranscript, listening, startListening, stopListening } = useSpeechRecognition();

  // Upload handler for the image file
  const handleFileUpload = (event) => {
    const file = event.target.files[0];
    if (file) {
      setOcrProcessing(true);
      Tesseract.recognize(
        file,
        'heb', // Use the 'heb' language code for Hebrew OCR
        {
          logger: (m) => console.log(m), // Optional: log OCR progress
        }
      ).then(({ data: { text } }) => {
        setOcrProcessing(false);
        parseDialogText(text);
        setPhase(2); // Move to the next phase (show text)
      }).catch((error) => {
        setOcrProcessing(false);
        console.error('OCR error:', error);
      });
    }
  };

  // Parse the OCR text into dialog lines
  const parseDialogText = (text) => {
    const dialogLines = text.split('\n').map((line) => {
      const parts = line.split(':');
      return { speaker: parts[0]?.trim(), text: parts[1]?.trim() || '' };
    }).filter(line => line.speaker && line.text); // Filter out empty lines
    setDialogText(dialogLines);
  };

  // Show the entire extracted text
  const handleShowEntireText = () => {
    setShowEntireText(a=>!a)
  };

  // Handle participant selection dynamically from the dialog text
  const handleParticipantSelect = (event) => {
    setCurrentParticipant(event.target.value);
    setLineIndex(0); // Start at the first line for new participant
  };

  // Get unique participant names
  const getParticipants = () => {
    const participants = [...new Set(dialogText.map(line => line.speaker))];
    return participants;
  };

  // Playback function for the other participant's line
  // const handlePlayLine = () => {
  //   if (dialogText[lineIndex]) {
  //     const line = dialogText[lineIndex];
  //     if (line.speaker !== currentParticipant) {
  //       const utterance = new SpeechSynthesisUtterance(line.text);
  //       speechSynthesis.speak(utterance);
  //     }
  //   }
  // };

  // Handle checking the line
  // const handleCheckLine = () => {
  //   if (dialogText[lineIndex]) {
  //     alert(`Your line: ${dialogText[lineIndex].text}`);
  //   }
  // };

  // // Handle recording the user's response
  // const handleStartRecording = () => {
  //   startListening();
  //   setIsRecording(true);
  // };

  // const handleStopRecording = () => {
  //   stopListening();
  //   setIsRecording(false);
  // };

  const handleNextLine = () => {
    if (lineIndex < dialogText.length - 1) {
      setLineIndex(lineIndex + 1);
    } else {
      alert('End of dialog.');
    }
  };
  const resetLineIndex = () => {
    
      setLineIndex(0);
    
  };
  

  const handleBack = () => {
    if (phase === 2) {
      setPhase(1); // Back to file upload phase
    } else if (phase === 3) {
      setPhase(2); // Back to show text phase
    }
  };

  return (
    <div className="App">
      <h1>Dialog Practice</h1>

      {phase === 1 && (
        <div>
          <h2>Upload your file</h2>
          <input type="file" accept="image/*" onChange={handleFileUpload} />
          {ocrProcessing && <p>Processing image...</p>}
        </div>
      )}

      {phase === 2 && (
        <div>
          
          <h2>Extracted Text</h2>
          <div className="text-container">
            <button onClick={handleShowEntireText}>{showEntireText?'Hide  Entire Text':'Show Entire Text'}`</button>
            {showEntireText && (  <div className="scrollable-text">
              {dialogText.map((line, index) => (
                <p key={index}><strong>{line.speaker}:</strong> {line.text}</p>
              ))}
            </div>)}
          </div>
          <button onClick={() => setPhase(3)}>Start Practice</button>
        </div>
      )}

      {phase === 3 && (
        <div className="practice-container">
          <h2>Practice Dialog</h2>

          <label>Select Participant: </label>
          <select value={currentParticipant} onChange={handleParticipantSelect}>
            <option value="">Select...</option>
            {getParticipants().map((participant, index) => (
              <option key={index} value={participant}>{participant}</option>
            ))}
          </select>

          <div>
            {currentParticipant && (
              <p><strong>{dialogText[lineIndex]?.speaker}:</strong> {dialogText[lineIndex]?.text}</p>
            )}
          </div>

          <button onClick={handleNextLine}>Next Line</button>
          <button onClick={resetLineIndex}>from the start</button>
        </div>
      )}

      <button onClick={handleBack} className="back-btn">Back</button>
    </div>
  );
};

export default App;
